export enum PackagingOptions {
  KnockedDown = 1,
  Assembled,
  DoorsOnly,
}
